var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { GalaxyApi } from "@/api";
import { errorMessageAsString } from "@/utils/simple-error";
export const useObjectStoreInstancesStore = defineStore("objectStoreInstances", {
    state: () => ({
        instances: [],
        fetched: false,
        error: null,
    }),
    getters: {
        getInstances: (state) => {
            return state.instances;
        },
        loading: (state) => {
            return !state.fetched;
        },
        getInstance: (state) => {
            return (uuid) => state.instances.find((i) => i.uuid == uuid);
        },
    },
    actions: {
        handleInit(instances) {
            return __awaiter(this, void 0, void 0, function* () {
                this.instances = instances;
                this.fetched = true;
                this.error = null;
            });
        },
        handleError(err) {
            return __awaiter(this, void 0, void 0, function* () {
                this.error = errorMessageAsString(err);
            });
        },
        fetchInstances() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data: instances, error } = yield GalaxyApi().GET("/api/object_store_instances");
                if (error) {
                    this.handleError(error);
                    return;
                }
                this.handleInit(instances);
            });
        },
        ensureTemplates() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.fetched || this.error != null) {
                    yield this.fetchInstances();
                }
            });
        },
    },
});
